import { Grid2 } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormField, FormFieldType } from '@enroller/admissions-components';

import { API_FIELDS_APPLICATION as APPLICATION } from '@enroller/admissions-components';

import { TitledSection } from '../../../layout/TitledSection';
import { yesNoOptions } from '../../../constants/yesNoOptions';
import { HousingFormValues, HOUSING_PAGE_SECTIONS } from './HousingFormValues';

export const FoodSection = () => {
  const { control } = useFormContext<HousingFormValues>();

  const section = HOUSING_PAGE_SECTIONS.food;
  const dietaryRestrictionsPath = `${section}.${APPLICATION.dietRestricted}.value`;
  const mealPrepPath = `${section}.${APPLICATION.dietRestricted}.${APPLICATION.prepareOwnMeals}`;
  const vegetarianAdjustmentPath = `${section}.${APPLICATION.adjustToVegetarian}`;

  const watchDietaryRestrictions = useWatch({ control, name: dietaryRestrictionsPath });

  return (
    <TitledSection title="Food">
      <Grid2 size={12}>
        <FormField
          control={control}
          name={dietaryRestrictionsPath}
          type={FormFieldType.Radio}
          options={yesNoOptions}
          label="Is your diet restricted by food allergies, religious or self-imposed beliefs (e.g. vegetarian, vegan, gluten-free)?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={mealPrepPath}
          type={FormFieldType.Radio}
          options={yesNoOptions}
          disabled={watchDietaryRestrictions !== 'yes'}
          label="Because your diet is restricted, would you be willing/able to prepare your own meals while in your homestay?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={vegetarianAdjustmentPath}
          type={FormFieldType.Radio}
          options={yesNoOptions}
          label="Can you adjust to a home where the family eats only a vegetarian diet?"
        />
      </Grid2>
    </TitledSection>
  );
};
